import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { uniq } from 'lodash-es';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Colour } from 'src/app/models/domain';
import { ColourAdapter } from 'src/app/models/domain/adapters';
import { YPMCOLOURVService } from 'src/generated-clients/colour';
import { YPMMULTICOLOURVCDSYPMCOLOURVType } from 'src/generated-clients/multicolour';

@Injectable({
  providedIn: 'root',
})
export class ColourDataService {
  private readonly colourIdPropertyName: keyof YPMMULTICOLOURVCDSYPMCOLOURVType = 'colourId';

  public constructor(
    private readonly colourService: YPMCOLOURVService,
    private readonly colourAdapter: ColourAdapter
  ) {}

  public getColoursByColourIds(colourIds: string[]): Observable<Colour[]> {
    const colourFilter = uniq(
      colourIds.map((id) => `${this.colourIdPropertyName} eq '${id}'`)
    ).join(' or ');

    return this.colourService.yPMCOLOURVGet(undefined, undefined, colourFilter).pipe(
      rethrowAsSapError(),
      map((res) => {
        if (!res.d?.results) {
          throw new Error('SAP Error');
        }

        return res.d.results.map((colour) => this.colourAdapter.adaptToDomain(colour));
      })
    );
  }
}
